

export const AREAS_OF_LIFE_ANALYSIS_CONSTANTS = {
  财帛: {
    紫微: {
      score: 81,
      description:
        "紫微星化禄于财帛宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你学习理财知识，提升财务独立性。",
    },
    天机: {
      score: 81,
      description:
        "天机星化权于财帛宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你学习理财知识，提升财务独立性。",
    },
    太阳: {
      score: 71,
      description:
        "太阳星化禄于财帛宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你学习理财知识，提升财务独立性。",
    },
    武曲: {
      score: 65,
      description:
        "武曲星化禄于财帛宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你学习理财知识，提升财务独立性。",
    },
    天同: {
      score: 80,
      description:
        "天同星化科于财帛宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你学习理财知识，提升财务独立性。",
    },
    廉贞: {
      score: 85,
      description:
        "廉贞星化权于财帛宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你学习理财知识，提升财务独立性。",
    },
    天府: {
      score: 78,
      description:
        "天府星化科于财帛宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你学习理财知识，提升财务独立性。",
    },
    太阴: {
      score: 95,
      description:
        "太阴星化科于财帛宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你学习理财知识，提升财务独立性。",
    },
    贪狼: {
      score: 62,
      description:
        "贪狼星化权于财帛宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你学习理财知识，提升财务独立性。",
    },
    巨门: {
      score: 91,
      description:
        "巨门星化科于财帛宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你学习理财知识，提升财务独立性。",
    },
    天相: {
      score: 73,
      description:
        "天相星化科于财帛宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你学习理财知识，提升财务独立性。",
    },
    天梁: {
      score: 62,
      description:
        "天梁星化忌于财帛宫，带来挑战或内耗，提醒你要多反思与调整。这是提醒你去面对深层课题，调整习惯，转化为成长。建议你学习理财知识，提升财务独立性。",
    },
    七杀: {
      score: 66,
      description:
        "七杀星化禄于财帛宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你学习理财知识，提升财务独立性。",
    },
    破军: {
      score: 94,
      description:
        "破军星化科于财帛宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你学习理财知识，提升财务独立性。",
    },
    左輔: {
      score: 75,
      description:
        "左辅星在财帛宫，带来人脉与外援，适合团队合作或借助贵人之力发财。但须留意是否过度依赖他人意见。",
    },
    右弼: {
      score: 75,
      description:
        "右弼星在财帛宫，有助于协调关系与合作，财运多来自社交圈或合作项目。注意需谨慎选择合作对象。",
    },
    文昌: {
      score: 78,
      description:
        "文昌星在财帛宫，带来思维清晰与表达能力，有助于通过知识、写作或沟通获利。但需避免过度思虑影响决策。",
    },
    文曲: {
      score: 78,
      description:
        "文曲星在财帛宫，有艺术与美感带财之象，适合从事创意、文化相关行业。小心感性消费导致开销增加。",
    },
  },
  官禄: {
    紫微: {
      score: 82,
      description:
        "紫微星化禄于官禄宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你专注职业规划，提升专业能力。",
    },
    天机: {
      score: 73,
      description:
        "天机星化忌于官禄宫，带来挑战或内耗，提醒你要多反思与调整。这是提醒你去面对深层课题，调整习惯，转化为成长。建议你专注职业规划，提升专业能力。",
    },
    太阳: {
      score: 62,
      description:
        "太阳星化权于官禄宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你专注职业规划，提升专业能力。",
    },
    武曲: {
      score: 80,
      description:
        "武曲星化权于官禄宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你专注职业规划，提升专业能力。",
    },
    天同: {
      score: 83,
      description:
        "天同星化忌于官禄宫，带来挑战或内耗，提醒你要多反思与调整。这是提醒你去面对深层课题，调整习惯，转化为成长。建议你专注职业规划，提升专业能力。",
    },
    廉贞: {
      score: 83,
      description:
        "廉贞星化禄于官禄宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你专注职业规划，提升专业能力。",
    },
    天府: {
      score: 78,
      description:
        "天府星化权于官禄宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你专注职业规划，提升专业能力。",
    },
    太阴: {
      score: 70,
      description:
        "太阴星化忌于官禄宫，带来挑战或内耗，提醒你要多反思与调整。这是提醒你去面对深层课题，调整习惯，转化为成长。建议你专注职业规划，提升专业能力。",
    },
    贪狼: {
      score: 73,
      description:
        "贪狼星化禄于官禄宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你专注职业规划，提升专业能力。",
    },
    巨门: {
      score: 92,
      description:
        "巨门星化忌于官禄宫，带来挑战或内耗，提醒你要多反思与调整。这是提醒你去面对深层课题，调整习惯，转化为成长。建议你专注职业规划，提升专业能力。",
    },
    天相: {
      score: 92,
      description:
        "天相星化禄于官禄宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你专注职业规划，提升专业能力。",
    },
    天梁: {
      score: 65,
      description:
        "天梁星化禄于官禄宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你专注职业规划，提升专业能力。",
    },
    七杀: {
      score: 67,
      description:
        "七杀星化忌于官禄宫，带来挑战或内耗，提醒你要多反思与调整。这是提醒你去面对深层课题，调整习惯，转化为成长。建议你专注职业规划，提升专业能力。",
    },
    破军: {
      score: 81,
      description:
        "破军星化权于官禄宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你专注职业规划，提升专业能力。",
    },
    左輔: {
      score: 76,
      description:
        "左辅星在官禄宫，象征贵人提携与助力，职业发展过程中容易获得上司或前辈的支持。建议你善于表达并主动寻求指导，把握成长机会。",
    },
    右弼: {
      score: 76,
      description:
        "右弼星在官禄宫，有助于建立良好职场人际关系，适合团队合作，易得同事支持。注意保持协调，避免流于八面玲珑而失焦。",
    },
    文昌: {
      score: 80,
      description:
        "文昌星在官禄宫，有助于文书表达、逻辑思维和学术发展，适合从事教育、文案或顾问类工作。可通过进修提升职场竞争力。",
    },
    文曲: {
      score: 80,
      description:
        "文曲星在官禄宫，适合从事创意、艺术或设计相关职业，带来审美与沟通优势。注意情绪化表达可能影响专业形象。",
    },
  },
  疾厄: {
    紫微: {
      score: 91,
      description:
        "紫微星化权于疾厄宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你养成健康生活方式，注重身体信号。",
    },
    天机: {
      score: 75,
      description:
        "天机星化忌于疾厄宫，带来挑战或内耗，提醒你要多反思与调整。这是提醒你去面对深层课题，调整习惯，转化为成长。建议你养成健康生活方式，注重身体信号。",
    },
    太阳: {
      score: 81,
      description:
        "太阳星化权于疾厄宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你养成健康生活方式，注重身体信号。",
    },
    武曲: {
      score: 85,
      description:
        "武曲星化禄于疾厄宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你养成健康生活方式，注重身体信号。",
    },
    天同: {
      score: 79,
      description:
        "天同星化忌于疾厄宫，带来挑战或内耗，提醒你要多反思与调整。这是提醒你去面对深层课题，调整习惯，转化为成长。建议你养成健康生活方式，注重身体信号。",
    },
    廉贞: {
      score: 90,
      description:
        "廉贞星化忌于疾厄宫，带来挑战或内耗，提醒你要多反思与调整。这是提醒你去面对深层课题，调整习惯，转化为成长。建议你养成健康生活方式，注重身体信号。",
    },
    天府: {
      score: 93,
      description:
        "天府星化科于疾厄宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你养成健康生活方式，注重身体信号。",
    },
    太阴: {
      score: 73,
      description:
        "太阴星化禄于疾厄宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你养成健康生活方式，注重身体信号。",
    },
    贪狼: {
      score: 75,
      description:
        "贪狼星化禄于疾厄宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你养成健康生活方式，注重身体信号。",
    },
    巨门: {
      score: 61,
      description:
        "巨门星化科于疾厄宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你养成健康生活方式，注重身体信号。",
    },
    天相: {
      score: 85,
      description:
        "天相星化禄于疾厄宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你养成健康生活方式，注重身体信号。",
    },
    天梁: {
      score: 89,
      description:
        "天梁星化禄于疾厄宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你养成健康生活方式，注重身体信号。",
    },
    七杀: {
      score: 85,
      description:
        "七杀星化忌于疾厄宫，带来挑战或内耗，提醒你要多反思与调整。这是提醒你去面对深层课题，调整习惯，转化为成长。建议你养成健康生活方式，注重身体信号。",
    },
    破军: {
      score: 86,
      description:
        "破军星化禄于疾厄宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你养成健康生活方式，注重身体信号。",
    },
    左輔: {
      score: 74,
      description:
        "左辅星在疾厄宫，有贵人助力改善健康或带来医缘，适合与他人合作处理健康事务。注意自身健康责任不应完全依赖外力。",
    },
    右弼: {
      score: 74,
      description:
        "右弼星在疾厄宫，易得亲友帮助照顾健康，但也可能因他人事务而操劳，影响身体状况。适度分工，避免身心俱疲。",
    },
    文昌: {
      score: 77,
      description:
        "文昌星在疾厄宫，思虑较多，容易因神经紧张引发睡眠或消化系统问题。建议适度放松，培养规律生活与心灵调适。",
    },
    文曲: {
      score: 77,
      description:
        "文曲星在疾厄宫，情绪细腻易感，可能引发情绪性疾病或过敏反应。建议你重视情绪管理与心理健康的培养。",
    },
  },
  夫妻: {
    紫微: {
      score: 88,
      description:
        "紫微星化禄于夫妻宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    天机: {
      score: 94,
      description:
        "天机星化禄于夫妻宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    太阳: {
      score: 75,
      description:
        "太阳星化禄于夫妻宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    武曲: {
      score: 65,
      description:
        "武曲星化禄于夫妻宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    天同: {
      score: 63,
      description:
        "天同星化科于夫妻宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    廉贞: {
      score: 63,
      description:
        "廉贞星化禄于夫妻宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    天府: {
      score: 92,
      description:
        "天府星化科于夫妻宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    太阴: {
      score: 67,
      description:
        "太阴星化权于夫妻宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    贪狼: {
      score: 91,
      description:
        "贪狼星化权于夫妻宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    巨门: {
      score: 65,
      description:
        "巨门星化科于夫妻宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    天相: {
      score: 86,
      description:
        "天相星化权于夫妻宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    天梁: {
      score: 93,
      description:
        "天梁星化科于夫妻宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    七杀: {
      score: 71,
      description:
        "七杀星化科于夫妻宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    破军: {
      score: 79,
      description:
        "破军星化权于夫妻宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你建立真诚沟通，理解与包容彼此差异。",
    },
    左輔: {
      score: 75,
      description:
        "左辅星在夫妻宫，象征伴侣关系中容易获得理解与支持，是温和体贴的能量。适合共同成长，但也要注意不要一味迎合。",
    },
    右弼: {
      score: 75,
      description:
        "右弼星在夫妻宫，带来伴侣间的和谐互动，适合通过合作与沟通增进感情。注意不要因过度包容而压抑自身需求。",
    },
    文昌: {
      score: 79,
      description:
        "文昌星在夫妻宫，重视沟通与思想交流，有助于理性处理感情事务。建议在情感中加入更多温度，避免理性过头。",
    },
    文曲: {
      score: 79,
      description:
        "文曲星在夫妻宫，情感表达细腻，适合浪漫关系发展。但也需注意过于敏感或情绪化，容易引发误解或争执。",
    },
  },
  交友: {
    紫微: {
      score: 71,
      description:
        "紫微星化科于交友宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    天机: {
      score: 71,
      description:
        "天机星化禄于交友宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    太阳: {
      score: 60,
      description:
        "太阳星化权于交友宫，让你在该领域展现权威或主动性，容易掌控局势。但需警惕是否变得强势或过度控制，影响人际关系。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    武曲: {
      score: 84,
      description:
        "武曲星化科于交友宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    天同: {
      score: 73,
      description:
        "天同星化禄于交友宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    廉贞: {
      score: 80,
      description:
        "廉贞星化禄于交友宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    天府: {
      score: 70,
      description:
        "天府星化忌于交友宫，带来挑战或内耗，提醒你要多反思与调整。这是提醒你去面对深层课题，调整习惯，转化为成长。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    太阴: {
      score: 61,
      description:
        "太阴星化禄于交友宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    贪狼: {
      score: 73,
      description:
        "贪狼星化忌于交友宫，带来挑战或内耗，提醒你要多反思与调整。这是提醒你去面对深层课题，调整习惯，转化为成长。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    巨门: {
      score: 73,
      description:
        "巨门星化禄于交友宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    天相: {
      score: 65,
      description:
        "天相星化科于交友宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    天梁: {
      score: 85,
      description:
        "天梁星化禄于交友宫，带来好运与资源流动，容易得财或获得助力。但要注意是否因此依赖外在资源而忽略了自我成长。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    七杀: {
      score: 60,
      description:
        "七杀星化科于交友宫，增加智慧与受人尊重的机会，容易被看见和认可。但可能过于理性而压抑情绪，影响真实表达。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    破军: {
      score: 91,
      description:
        "破军星化忌于交友宫，带来挑战或内耗，提醒你要多反思与调整。这是提醒你去面对深层课题，调整习惯，转化为成长。建议你拓展交际圈，建立互相支持的人脉网络。",
    },
    左輔: {
      score: 76,
      description:
        "左辅星在交友宫，带来可靠与支持性的友人，适合建立长久稳定的人脉关系。建议你主动关怀他人，赢得信任与回报。",
    },
    右弼: {
      score: 76,
      description:
        "右弼星在交友宫，有助于建立圆融和谐的社交环境，人缘佳但需注意界限感。适合发展广泛而有策略的人脉网络。",
    },
    文昌: {
      score: 78,
      description:
        "文昌星在交友宫，重视知识性交流，朋友多为思想或学术型人士。建议你多参与讲座、社群等提升见识的场合。",
    },
    文曲: {
      score: 78,
      description:
        "文曲星在交友宫，擅长人际沟通与表达，适合艺术、文化圈发展。友情中可能较敏感，需学会情绪调节与倾听。",
    },
  },
  兄弟: {
    紫微: {
      score: 72,
      description: "紫微星在兄弟宫，兄弟姐妹多具领导气质，关系中讲求尊重与信任。你在兄弟姊妹间可能具备一定权威或照顾者角色。"
    },
    天机: {
      score: 68,
      description: "天机星在兄弟宫，兄弟姐妹聪明机敏，互动频繁但变化多。关系可能起伏较大，需多沟通协调。"
    },
    太阳: {
      score: 74,
      description: "太阳星在兄弟宫，兄弟姐妹热情慷慨，乐于助人。你与兄弟姊妹关系偏阳性互动，适合建立正向合作。"
    },
    武曲: {
      score: 70,
      description: "武曲星在兄弟宫，兄弟姊妹务实独立，重视实际利益。相处中可能带有竞争性，但也能彼此成就。"
    },
    天同: {
      score: 77,
      description: "天同星在兄弟宫，兄弟姐妹温和友善，情感关系较紧密。家庭气氛和谐，适合互助扶持。"
    },
    廉贞: {
      score: 65,
      description: "廉贞星在兄弟宫，兄弟姊妹之间可能存在摩擦或争执，互动带有挑战性。建议建立清晰界限与共识。"
    },
    天府: {
      score: 73,
      description: "天府星在兄弟宫，兄弟姊妹较为稳定可靠，常扮演支援角色。家庭氛围较安定，易得亲情支持。"
    },
    太阴: {
      score: 75,
      description: "太阴星在兄弟宫，兄弟姊妹细腻体贴，情感连接强。你可能特别重视手足情谊，愿意为他们付出。"
    },
    贪狼: {
      score: 66,
      description: "贪狼星在兄弟宫，兄弟姊妹个性强烈，生活方式差异大。关系中需包容多元，避免冲突。"
    },
    巨门: {
      score: 64,
      description: "巨门星在兄弟宫，沟通较易产生误解，兄弟姊妹间可能常有争论。建议建立开放对话管道。"
    },
    天相: {
      score: 78,
      description: "天相星在兄弟宫，兄弟姊妹温文有礼，重视公平和协调。适合共事合作，关系较为平稳。"
    },
    天梁: {
      score: 76,
      description: "天梁星在兄弟宫，兄弟姊妹有长者风范，常给予照顾或指导。关系中你可能是依赖方或支援者。"
    },
    七杀: {
      score: 62,
      description: "七杀星在兄弟宫，关系较有距离，互动可能较冷淡或竞争。建议多主动关怀，减少误解。"
    },
    破军: {
      score: 60,
      description: "破军星在兄弟宫，兄弟姊妹间可能经历较多变化或分离。关系需靠时间修复与理解。"
    },
    左輔: {
      score: 80,
      description: "左辅星在兄弟宫，兄弟姊妹是你的得力助手，乐于协助。适合建立互助共荣的关系。"
    },
    右弼: {
      score: 80,
      description: "右弼星在兄弟宫，兄弟姊妹圆融和善，关系中常能彼此支持与理解。人际互动良好。"
    },
    文昌: {
      score: 74,
      description: "文昌星在兄弟宫，兄弟姊妹聪慧好学，交流顺畅。你们可能有共同兴趣或学术话题。"
    },
    文曲: {
      score: 74,
      description: "文曲星在兄弟宫，兄弟姊妹情感细腻，擅于沟通表达。适合心灵交流与文化艺术互动。"
    }
  },
  福德: {
    紫微: {
      score: 75,
      description: "紫微星在福德宫，内心追求尊贵与成就，拥有高尚理想。你适合从精神层次寻找满足感，拥有良好的气场。"
    },
    天机: {
      score: 70,
      description: "天机星在福德宫，思想活跃，喜欢学习与思考，容易获得内在平静。适合静态修养与智慧发展。"
    },
    太阳: {
      score: 73,
      description: "太阳星在福德宫，性格阳光乐观，内在能量充沛。容易因助人为乐而获得满足，适合发展公益或服务精神。"
    },
    武曲: {
      score: 66,
      description: "武曲星在福德宫，重视物质安全，精神寄托较务实。适合通过工作成就感获得内在安稳。"
    },
    天同: {
      score: 82,
      description: "天同星在福德宫，天性乐观平和，享受简单生活。容易感到幸福，拥有良好的心理调适能力。"
    },
    廉贞: {
      score: 64,
      description: "廉贞星在福德宫，内心情绪起伏大，常有强烈执念。建议学习放下与释放，才能获得真正宁静。"
    },
    天府: {
      score: 78,
      description: "天府星在福德宫，内心稳重安定，重视生活品质。适合发展稳固的精神信仰与生活节奏。"
    },
    太阴: {
      score: 76,
      description: "太阴星在福德宫，情感细腻，重视精神寄托。适合静态生活或艺术修养，容易自我满足。"
    },
    贪狼: {
      score: 65,
      description: "贪狼星在福德宫，内心欲望较强，追求感官享乐。需警惕情绪依赖或放纵，建议平衡物质与精神需求。"
    },
    巨门: {
      score: 60,
      description: "巨门星在福德宫，思虑多、杂念重，容易陷入自我怀疑。建议培养正向思维与静心习惯。"
    },
    天相: {
      score: 74,
      description: "天相星在福德宫，内心平衡感强，能维持良好的精神状态。适合规律生活与和谐的人际互动。"
    },
    天梁: {
      score: 80,
      description: "天梁星在福德宫，有宗教哲学倾向，适合追求精神成长。内在有稳定的信仰力量。"
    },
    七杀: {
      score: 58,
      description: "七杀星在福德宫，内心较波动，难以安定。适合透过挑战与突破寻找人生意义。"
    },
    破军: {
      score: 56,
      description: "破军星在福德宫，精神状态多变化，容易陷入迷惘或空虚。建议建立长期目标与正向价值。"
    },
    左輔: {
      score: 77,
      description: "左辅星在福德宫，内心正直，有助于建立稳定的精神支持系统。适合从助人中获得满足。"
    },
    右弼: {
      score: 77,
      description: "右弼星在福德宫，个性温和易亲近，精神层面偏向安稳圆融。适合团体中寻求心灵归属。"
    },
    文昌: {
      score: 72,
      description: "文昌星在福德宫，喜欢静思与阅读，适合学术与哲思。精神寄托多来自知识层面。"
    },
    文曲: {
      score: 72,
      description: "文曲星在福德宫，艺术气质浓厚，适合音乐、文学等带来内在滋养。情绪起伏需学会平衡。"
    }
  },
  父母: {
    紫微: {
      score: 74,
      description: "紫微星在父母宫，父母权威性强，对你期望高。亲子关系中尊重与责任感是关键课题。"
    },
    天机: {
      score: 69,
      description: "天机星在父母宫，父母思维活跃，可能较忙碌。互动上多变动，建议多主动沟通。"
    },
    太阳: {
      score: 77,
      description: "太阳星在父母宫，父母热情外向，给予你许多鼓励。你在家庭中容易受到重视与支持。"
    },
    武曲: {
      score: 68,
      description: "武曲星在父母宫，父母重实际与规范，教育方式务实。你在成长中可能较早独立。"
    },
    天同: {
      score: 75,
      description: "天同星在父母宫，父母温和亲切，家庭气氛较温馨。亲子间多有情感交流。"
    },
    廉贞: {
      score: 65,
      description: "廉贞星在父母宫，父母个性较强，互动可能有冲突。亲子关系中建议保持弹性。"
    },
    天府: {
      score: 78,
      description: "天府星在父母宫，父母稳重可靠，给予良好生活条件。家庭中常有实质支持。"
    },
    太阴: {
      score: 76,
      description: "太阴星在父母宫，母亲角色影响较大，亲情浓厚。家庭多柔性照顾与情感滋养。"
    },
    贪狼: {
      score: 66,
      description: "贪狼星在父母宫，父母个性外放，生活多采多姿。亲子间需协调生活节奏与界限。"
    },
    巨门: {
      score: 62,
      description: "巨门星在父母宫，沟通上易有误解，家庭中常需澄清与协调。建议多用耐心聆听父母。"
    },
    天相: {
      score: 74,
      description: "天相星在父母宫，父母持中守正，注重礼仪与规范。亲子关系重在相互尊重。"
    },
    天梁: {
      score: 79,
      description: "天梁星在父母宫，父母多为慈祥长者，重视伦理与照顾责任。适合从长辈中学习智慧。"
    },
    七杀: {
      score: 60,
      description: "七杀星在父母宫，父母可能严厉或分隔较多，互动上需建立互信。成长过程较独立。"
    },
    破军: {
      score: 58,
      description: "破军星在父母宫，家庭结构可能变动频繁，或亲子关系较疏远。建议主动培养连接感。"
    },
    左輔: {
      score: 78,
      description: "左辅星在父母宫，父母给予你实际帮助与指导，是成长过程中的贵人。"
    },
    右弼: {
      score: 78,
      description: "右弼星在父母宫，父母亲切支持你的人际发展。亲子关系多为互相理解与信赖。"
    },
    文昌: {
      score: 73,
      description: "文昌星在父母宫，父母重视教育与修养。你从小受到良好知识环境熏陶。"
    },
    文曲: {
      score: 73,
      description: "文曲星在父母宫，家庭重视文化艺术氛围，亲子间常有情感交流与美感互动。"
    }
  }
      
};
